import { repositoryMutation, requiredString } from "./transaction.js";
export class SqliteSettingsRepository {
    #database;
    #now;
    constructor(database, options = {}) {
        this.#database = database;
        this.#now = options.now ?? (() => new Date().toISOString());
    }
    delete(key) {
        return repositoryMutation(this.#database, (transaction) => {
            if (transaction.selectValue("SELECT COUNT(*) FROM client_settings WHERE key = ?", [key]) !== 1) {
                return undefined;
            }
            transaction.exec("DELETE FROM client_settings WHERE key = ?", { bind: [key] });
            return { entityId: key, event: settingEvent("deleted", key, this.#now()) };
        });
    }
    async list() {
        return this.#database.selectObjects("SELECT key, value_json, updated_at FROM client_settings ORDER BY key").map(settingRecord);
    }
    async read(key) {
        const row = this.#database.selectObject("SELECT key, value_json, updated_at FROM client_settings WHERE key = ?", [key]);
        return row === undefined ? undefined : settingRecord(row);
    }
    set(input) {
        return repositoryMutation(this.#database, (transaction) => {
            const action = transaction.selectValue("SELECT COUNT(*) FROM client_settings WHERE key = ?", [input.key]) === 1 ? "updated" : "created";
            const updatedAt = this.#now();
            transaction.exec(`INSERT INTO client_settings(key, value_json, updated_at) VALUES (?, ?, ?)
          ON CONFLICT(key) DO UPDATE SET
            value_json = excluded.value_json,
            updated_at = excluded.updated_at`, { bind: [input.key, JSON.stringify(input.value), updatedAt] });
            return { entityId: input.key, event: settingEvent(action, input.key, updatedAt) };
        });
    }
}
function isRepositoryJsonValue(value) {
    if (value === null || typeof value === "boolean" || typeof value === "string")
        return true;
    if (typeof value === "number")
        return Number.isFinite(value);
    if (Array.isArray(value))
        return value.every(isRepositoryJsonValue);
    if (typeof value !== "object")
        return false;
    return Object.values(value).every(isRepositoryJsonValue);
}
function settingEvent(action, key, occurredAt) {
    return {
        occurredAt,
        payload: { action, entityId: key, entityType: "setting" },
        type: "domain.entity-changed",
    };
}
function settingRecord(row) {
    const value = JSON.parse(requiredString(row.value_json, "setting value_json"));
    if (!isRepositoryJsonValue(value))
        throw new TypeError("Stored setting value is not JSON");
    return {
        key: requiredString(row.key, "setting key"),
        updatedAt: requiredString(row.updated_at, "setting updated_at"),
        value,
    };
}
//# sourceMappingURL=settings.js.map